import { useEffect, useState } from 'react';
import {
  fetchExerciseStyles,
  type ExerciseStylesRecord,
} from 'util/moviefoneExerciseStyles';

const useExerciseStyles = (
  symbol: string | null | undefined,
): ExerciseStylesRecord | null => {
  const [exerciseStyles, setExerciseStyles] =
    useState<ExerciseStylesRecord | null>(null);

  useEffect(() => {
    if (symbol == null || symbol === '') {
      setExerciseStyles(null);
      return;
    }
    let cancelled = false;
    void fetchExerciseStyles(symbol).then((styles) => {
      if (!cancelled) {
        setExerciseStyles(styles);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [symbol]);

  return exerciseStyles;
};

export default useExerciseStyles;
